export const DEFAULT_FROM = 540; //  9:00 or 9AM
export const DEFAULT_TO = 1020; // 17:00 or 5PM

export const DEFAULT_HOURS = { from: DEFAULT_FROM, to: DEFAULT_TO };

export const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const DEFAULT_WORKING_HOURS = {
  monday: DEFAULT_HOURS,
  tuesday: DEFAULT_HOURS,
  wednesday: DEFAULT_HOURS,
  thursday: DEFAULT_HOURS,
  friday: DEFAULT_HOURS,
  saturday: DEFAULT_HOURS,
  sunday: DEFAULT_HOURS,
};

export const MIN_SLIDER_TIME = 60; // 1:00 or 1AM
export const MAX_SLIDER_TIME = 1380; // 23:00 or 11PM
export const SLIDER_STEPS = 15;
